// The inline chips a task title can carry - an @-mentioned contact, company
// or teammate - and the side panel each one opens. Shared by every view that
// renders titles with chips (the outline, board cards, mind-map nodes), so a
// chip opens the same card wherever it is clicked.
//
// Contact and company chips are spans carrying data-mention="kind:ID". A
// teammate chip (@[Name](user:ID)) is a real link to /u/ID, which is what a
// modified click still opens; a plain click shows YOUR card for them instead
// (contacts#member_detail_panel).
const SELECTOR = '[data-mention^="contact:"], [data-mention^="company:"], a.task-mention[href^="/u/"]'
const PATHS = { contact: "contacts", company: "companies", user: "people" }

// The chip under a click, with data-detail-url set for detail-modal, or null.
// Modified clicks are left to the browser (a teammate chip opens in a tab).
export function mentionChipFor(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null
    const chip = event.target.closest?.(SELECTOR)
    if (!chip) return null

    const [kind, id] = chip.dataset.mention ? chip.dataset.mention.split(":") : ["user", chip.getAttribute("href").split("/")[2]]
    if (!PATHS[kind] || !/^\d+$/.test(id || "")) return null

    chip.dataset.detailUrl = `/network/${PATHS[kind]}/${id}/detail`
    return chip
}
